import React, {useState} from "react";
import {withStyles} from "@material-ui/core";
import i18n from "../../../i18n";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import {fileData} from "../../Utilities";
import swal from "sweetalert";
import {swalCancelDelete} from "../../Form/utils";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import _ from "lodash";

const deleteRelation = async (file,entity) => {

    if(file && entity.id) {
        let idx = _.findIndex(file.aRelations, 'project_id');
        let rel = idx >= 0 && file.aRelations[idx];
        if(rel && (parseInt(rel.project_id) === parseInt(entity.id) )) {
            await axios.delete(
                '/f/reference',
                {data: {relid: rel.id}}
            ).then((response) => {
                _.remove(file.aRelations, (itm, relidx) => {
                    return idx === relidx;
                });
            });
        }
    }
    return file;
}

const deleteFile = async (file, entity) => {

    return swal({
        title: i18n.get('file.delete.label'),
        text: i18n.get('file.delete.question'),
        dangerMode: true,
        icon: 'warning',
        closeOnClickOutside: false,
        closeOnEsc: false,
        ...swalCancelDelete(),
    }).then( async (confirmed) => {
        if (confirmed) {
            file = await deleteRelation(file,entity).then(file => file);
            if(!file.aRelations || !file.aRelations.length) {
                file = await axios.delete(file.sRouteDelete, {}).then((response) => {
                    if (response.data && response.data.success) {
                        file.isDeleted = true;
                        return file;
                    }
                })
            }
            return file;
        }
    });
}

const DocumentsRow = (props) => {
    const {meta, entity, file, openDialog, removeFile, classes} = props;

    const windowConfig = 'toolbar=0,status=0,width=650,height=900';
    const rowFileData = fileData(file,entity);

    const fileName = rowFileData.name;
    const preview = file.isNew
        ? '/f/preview/' + file.sHash
        : file.sRoutePreview;

    return (
        <TableRow
            className={classes.clickable}
            onClick={() => window.open( preview , 'docPrev', windowConfig)}
        >
            <TableCell>{fileName}</TableCell>
            {!meta && (
                <React.Fragment>
                    <TableCell align={'center'}>{file.oType && file.oType.name}</TableCell>
                    <TableCell align={'center'}>{file.sCreated && file.sCreated}</TableCell>
                </React.Fragment>
            )}
            <TableCell align={'center'} onClick={ e => { e.stopPropagation('all'); } } style={{cursor:'default'}}>
                <IconButton
                    component="a"
                    size={'small'}
                    onClick={() => file.isNew
                        ? removeFile(file)
                        : deleteFile(file, entity).then( e => {
                            if(e){
                                swal({
                                    text: i18n.get('file.removed'),
                                    icon: 'success',
                                    closeOnClickOutside: false,
                                    closeOnEsc: false,
                                }).then( () => removeFile(e) )
                            }
                        } )
                    }
                >
                    <Icon>delete</Icon>
                </IconButton>
                {!file.isNew &&
                    <IconButton
                        component="a"
                        size={'small'}
                        onClick={() => openDialog(file)}
                    >
                        <Icon>edit</Icon>
                    </IconButton>
                }
            </TableCell>
        </TableRow>
    );
}

const styles = theme => ({
    clickable: {
        cursor: 'pointer',
    },
});

export default withStyles(styles)(DocumentsRow);
